import React from "react";
import { Box, Button, Card, Title, Text } from "@nimbus-ds/components";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

interface CustomCardProps {
  title: string;
  text: string;
  buttonText: string;
  route: string;
}

const CustomCard: React.FC<CustomCardProps> = ({
  title,
  text,
  buttonText,
  route,
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(route);
  };

  return (
    <Card padding="none">
      <React.Fragment key=".0">
        <Card.Header padding="base">
          <Box
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Title as="h4">
              <FormattedMessage id={title} defaultMessage={title} />
            </Title>
          </Box>
        </Card.Header>
        <Card.Body padding="base">
          <Text textAlign="left">
            <FormattedMessage id={text} defaultMessage={text} />
          </Text>
        </Card.Body>
        <Card.Footer padding="base">
          <Button appearance="neutral" onClick={handleButtonClick}>
            <FormattedMessage id={buttonText} defaultMessage={buttonText} />
          </Button>
        </Card.Footer>
      </React.Fragment>
    </Card>
  );
};

export default CustomCard;
